import {ADD_CHATS, ChatsActionTypes, IEntityChatsState, REMOVE_CHAT, REPLACE_CHATS} from '../../types/entity/chats';
import {INIT_STORE} from "../../types/init";
import lod from 'lodash';

const initialState: IEntityChatsState = {
  byId: {},
  allIds: []
};

export function entityChatsReducer(
  state = initialState,
  action: ChatsActionTypes
): IEntityChatsState {
  switch (action.type) {
    case INIT_STORE:
      return initialState;
    case REPLACE_CHATS: {
      return {
        byId: lod.keyBy(action.payload.chats, 'id'),
        allIds: lod.map(action.payload.chats, 'id')
      };
    }
    case ADD_CHATS: {
      return {
        byId: {
          ...state.byId,
          ...lod.keyBy(action.payload.chats, 'id')
        },
        allIds: [
          ...state.allIds,
          ...lod.map(action.payload.chats, 'id').filter(id => !state.byId[id])
        ]
      };
    }
    case REMOVE_CHAT: {
      return {
        byId: lod.omit(state.byId, action.payload.id),
        allIds: state.allIds.filter(id => id !== action.payload.id)
      };
    }
    default:
      return state;
  }
}